var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWind(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.055 19.14H5.166v1.875h12.89c1.439 0 2.61 1.171 2.61 2.611a2.328 2.328 0 01-2.325 2.325 2.064 2.064 0 01-2.062-2.062h-1.875a3.942 3.942 0 003.937 3.937c2.316 0 4.2-1.884 4.2-4.2a4.491 4.491 0 00-4.486-4.486zM25.646 4.174a5.925 5.925 0 00-5.918 5.918h1.875a4.047 4.047 0 014.043-4.043c2.47 0 4.479 2.01 4.479 4.48a4.96 4.96 0 01-4.954 4.954H0v1.875h25.17a6.837 6.837 0 006.83-6.83 6.362 6.362 0 00-6.354-6.354z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.743 6.402a3.33 3.33 0 00-3.326 3.326h1.875c0-.8.651-1.451 1.451-1.451.916 0 1.66.745 1.66 1.66a1.89 1.89 0 01-1.887 1.888h-9.35V13.7h9.35a3.767 3.767 0 003.763-3.763 3.54 3.54 0 00-3.536-3.535z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWind);
var MemoForwardRef = /*#__PURE__*/React.memo(ForwardRef);
export default __webpack_public_path__ + "007f7216f457e2673d71493e755bc446.svg";
export { MemoForwardRef as ReactComponent };